// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2Rx5W","label":"Completed_label__Go6V7"};